import { IWeddingEvent } from '@bridebook/models/source/models/Weddings/Events.types';
import { getI18n } from '@bridebook/web/lib/i18n/getI18n';

export const fallbackMainEventName = (event: IWeddingEvent) => {
  const i18n = getI18n();
  return {
    ...event,
    name:
      event.name.trim() == '' ? i18n.t('weddingWebsite:events.mainEventDefaultName') : event.name,
  };
};
